import { useCliente } from "../context/ClienteContext";
import BackupMonitorPanel from "./backups/BackupMonitorPanel";
import "./BackupsModule.css";

// Transitional workspace for the agent-native platform.  The legacy Copias
// El módulo gestiona exclusivamente las copias propias mediante agentes.
export default function BackupTasksModule() {
  const { clienteSeleccionadoId, clienteInfo } = useCliente();
  const clientId = clienteSeleccionadoId ?? clienteInfo?.id ?? null;
  if (!clientId) return <div className="card">Selecciona un cliente para gestionar sus tareas de copia.</div>;
  return <div className="bk-module bk-new-module"><BackupMonitorPanel clientId={clientId} /></div>;
}
